module.exports = __webpack_public_path__ + "static/img/theme3.1976b351.jpg";